import { ProjectProduct } from '@/api/generated/model/projectProduct';
import { z } from 'zod';

export const ORG_PROJECT_NAME_MAX_LENGTH = 50;

const requiredNameSchema = z
  .string()
  .trim()
  .min(1, 'Required')
  .max(ORG_PROJECT_NAME_MAX_LENGTH, `Name must be at most ${ORG_PROJECT_NAME_MAX_LENGTH} characters`);

const productSchema = z.enum([ProjectProduct.internal, ProjectProduct.external]);

export const createOrganizationFormSchema = z.object({
  organizationName: requiredNameSchema,
  projectName: requiredNameSchema,
  product: productSchema,
});

export const createProjectFormSchema = z.object({
  projectName: requiredNameSchema,
  product: productSchema,
});

export type CreateOrganizationFormValues = z.infer<typeof createOrganizationFormSchema>;

export type CreateProjectFormValues = z.infer<typeof createProjectFormSchema>;
